
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Covid-19 durchläuft drei Stadien. Eine gesunde Person wird `}<strong parentName="p">{`infiziert`}</strong>{` und ist
vom Virus befallen. Sie ist aber noch nicht ansteckend für andere – dies
passiert erst ein paar Tage später. Eine `}<strong parentName="p">{`ansteckende`}</strong>{` Person kann das Virus
verbreiten, ohne Symptome zu spüren. Diese Phase verläuft unbemerkt und kann
mehrere Tage dauern, darum ist die Epidemie so schwer zu stoppen. Wenn
schliesslich die ersten Symptome auftreten, fühlt man sich `}<strong parentName="p">{`krank`}</strong>{`. Deutlich
mehr als 99 Prozent der Infizierten genesen (und sind dadurch wahrscheinlich
eine gewisse Zeit lang immun und nicht mehr ansteckend) – zwischen fünf und zehn
von 1000 Personen sterben.`}</p>
    <p><strong parentName="p">{`Starten Sie Ihren Weg durch die neue Normalität!`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;